import { memo } from 'react'

import CubeSelectNode from '../CubeSelectNode'

const GotoActionNode = ({ ...props }) => {
  return true ? <CubeSelectNode label="Ir a" allowEmpty {...props} /> : null
}
export default memo(GotoActionNode)
